var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3778F0",
    fillRule: "nonzero",
    d: "M18 8V2.994C18 1.426 16.55 0 15 0H2.812C1.262 0 0 1.275 0 2.843V11c0 1.568 1.45 3 3 3h12c1.55 0 3-1.38 3-2.948a.707.707 0 0 0-.703-.71.707.707 0 0 0-.703.71c0 .784-.819 1.948-1.594 1.948H3c-.775 0-2-1.216-2-2V2.994l6.515 3.839c.458.288.971.432 1.485.432.514 0 1.027-.144 1.485-.432L17 2.993V8h1zM9.743 5.626a1.385 1.385 0 0 1-1.486 0L1.993 1.688C2 1.421 2.694 1 3 1h12c.306 0 .776.52 1.007.688L9.743 5.626z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.3ee0f2c6b05d81506e0e9c0c3b644e8d.svg";
export { ForwardRef as ReactComponent };